'use client';
import { useTypedTranslation } from '@/hooks/useTypedTranslation';
import Button from '@/components/ui/button/Button';
import styles from './MerchantsHero.module.css';

export default function MerchantsHero({ selectedMarket }: { selectedMarket: 'es' | 'it' }) {
  const { t } = useTypedTranslation();

  return (
    <section className={styles.heroSection}>
      <div className={styles.textContent}>
        <div className={styles.textContainer}>
          <h1 className={styles.heading} suppressHydrationWarning>{t('merchants.hero.heading')}</h1>
          <p className={styles.description} suppressHydrationWarning>{t('merchants.hero.description')}</p>
        </div>
        <div className={styles.ctaContainer}>
          <Button
            variant="primary"
            className={styles.ctaButton}
            as="button"
            onClick={() => {
              const url = selectedMarket === 'it'
                ? 'https://signup.stampit.co/'
                : 'https://sales.askforstamp.com/signup';
              window.open(url, '_blank');
            }}
            suppressHydrationWarning
            id={selectedMarket === 'it' ? 'register_hero_it' : 'register_hero_es'}
            name="Register"
            title="Register from Hero"
          >
            {t('merchants.hero.ctaText')}
          </Button>
        </div>
      </div>
    </section>
  );
}
